import CryptoJS from 'crypto-js';

function encryptData(key, data) {
  const jsonString = JSON.stringify(data);

  const encryptedData = CryptoJS.AES.encrypt(jsonString, key).toString();

  return encodeURIComponent(encryptedData);
}

function decryptData(key, encryptedData) {
  const receivedEncryptedData = decodeURIComponent(encryptedData); // Decode URL safe version

  const bytes = CryptoJS.AES.decrypt(receivedEncryptedData, key);
  const decryptedJsonString = bytes.toString(CryptoJS.enc.Utf8);

  return JSON.parse(decryptedJsonString);
}

export default (key) => {
  const encrypt = (data) => {
    return encryptData(key, data);
  };

  const decrypt = (encryptedData, iv) => {
    return decryptData(key, encryptedData, iv);
  };

  return {
    encrypt,
    decrypt,
  };
};
